
export const projectsData = [
  {
    id: 1,
    title: 'Residencia Familia García',
    location: 'Madrid',
    type: 'Residencial',
    image: 'https://public.readdy.ai/ai/img_res/9bb86e1a0e1bcddc8d31fccf344be9ab.jpg',
    panels: 24,
    power: '10.8 kWp',
    savingsYear: 2340,
    savingsPercent: 78,
    co2Reduction: 4.2,
    completionDate: 'Marzo 2024',
  },
  {
    id: 2,
    title: 'Nave Industrial Logística Sur',
    location: 'Sevilla',
    type: 'Industrial',
    image: 'https://readdy.ai/api/search-image?query=large%20industrial%20warehouse%20rooftop%20covered%20with%20solar%20panels%2C%20aerial%20view%20of%20massive%20photovoltaic%20installation%20on%20factory%20building%20in%20Spain%2C%20professional%20photography%2C%20clean%20simple%20background%20with%20clear%20sky%2C%20commercial%20solar%20energy%20system&width=600&height=750&seq=project-gallery-2&orientation=portrait',
    panels: 320,
    power: '144 kWp',
    savingsYear: 38500,
    savingsPercent: 85,
    co2Reduction: 58.4,
    completionDate: 'Enero 2024',
  },
  {
    id: 3,
    title: 'Hotel Boutique Costa Brava',
    location: 'Girona',
    type: 'Empresarial',
    image: 'https://readdy.ai/api/search-image?query=boutique%20hotel%20building%20with%20solar%20panels%20on%20flat%20roof%2C%20Mediterranean%20coastal%20hotel%20with%20photovoltaic%20system%2C%20professional%20architecture%20photography%2C%20clean%20simple%20background%2C%20sustainable%20tourism%20energy%20solution%20in%20Spain&width=600&height=750&seq=project-gallery-3&orientation=portrait',
    panels: 86,
    power: '38.7 kWp',
    savingsYear: 12800,
    savingsPercent: 72,
    co2Reduction: 15.6,
    completionDate: 'Noviembre 2023',
  },
  {
    id: 4,
    title: 'Comunidad Vecinal El Prado',
    location: 'Valencia',
    type: 'Residencial',
    image: 'https://readdy.ai/api/search-image?query=modern%20apartment%20building%20rooftop%20with%20shared%20solar%20panel%20installation%2C%20community%20photovoltaic%20system%20on%20residential%20block%20in%20Spain%2C%20professional%20photography%2C%20clean%20simple%20background%20with%20warm%20sunlight%2C%20urban%20renewable%20energy&width=600&height=750&seq=project-gallery-4&orientation=portrait',
    panels: 48,
    power: '21.6 kWp',
    savingsYear: 5200,
    savingsPercent: 65,
    co2Reduction: 8.7,
    completionDate: 'Septiembre 2023',
  },
  {
    id: 5,
    title: 'Bodega Viedos del Norte',
    location: 'Segovia',
    type: 'Empresarial',
    image: 'https://static.readdy.ai/image/d37e4615f28c8b6905f3494c85f65781/d7a793c8bb56a3ffd32042b5cfe18965.jpeg',
    panels: 20,
    power: '50.4 kWp',
    savingsYear: 16400,
    savingsPercent: 80,
    co2Reduction: 20.3,
    completionDate: 'Febrero 2026',
  },
  {
    id: 6,
    title: 'Centro Comercial Plaza Mayor',
    location: 'Málaga',
    type: 'Industrial',
    image: 'https://readdy.ai/api/search-image?query=shopping%20center%20rooftop%20with%20large%20solar%20panel%20array%2C%20commercial%20building%20photovoltaic%20installation%20in%20southern%20Spain%2C%20professional%20aerial%20photography%2C%20clean%20simple%20background%20with%20blue%20sky%2C%20modern%20retail%20renewable%20energy%20system&width=600&height=750&seq=project-gallery-6&orientation=portrait',
    panels: 540,
    power: '243 kWp',
    savingsYear: 62000,
    savingsPercent: 88,
    co2Reduction: 98.5,
    completionDate: 'Mayo 2023',
  },
];

export const projectStats = {
  totalProjects: 850,
  totalPanels: 127000,
  totalSavings: 18.5,
  totalCO2: 42000,
};
